import * as React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'inline-flex items-center rounded border px-2 py-0.5 text-[0.7rem] font-semibold transition-colors',
  {
    variants: {
      variant: {
        default:     'border-transparent bg-primary text-primary-foreground',
        secondary:   'border-transparent bg-card text-muted-foreground',
        destructive: 'border-transparent bg-destructive text-destructive-foreground',
        outline:     'border-border text-foreground',
        win:         'border-transparent bg-winbg text-win',
        loss:        'border-transparent bg-lossbg text-loss',
        // Logic type badges (used in Clustering)
        trend:    'bg-[#1a2e4a] text-[#60a5fa] border-[#1d3a60]',
        meanrev:  'bg-[#2a1a4a] text-[#c084fc] border-[#3a1d60]',
        breakout: 'bg-[#3a2000] text-[#fb923c] border-[#4a2800]',
        momentum: 'bg-[#0f2e1a] text-[#4ade80] border-[#153a20]',
      },
    },
    defaultVariants: { variant: 'secondary' },
  }
);

function Badge({ className, variant, ...props }) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
